import { Typography } from "@mui/material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { useTranslation } from "react-i18next";
import { PictureUploadSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/pictureUploadSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: PictureUploadSubtypeDataModel;
}

export default function PictureUploadSubtypeDetails(props: Props) {
    const { t } = useTranslation();

    return <>
        <Typography variant="subtitle1">{t("incentivationPage.pictureUpload.uploadedImage")}</Typography>
        <img
            style={{ maxHeight: "400px", maxWidth: "100%", objectFit: "contain" }}
            src={props.subtypeData.uploadedImageUrl} />
    </>
}
